import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as Hammer from 'hammerjs';
import { Observable, Subject, zip } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import {
   AppConfig,
   BackendResponse,
   DateService,
   DBService,
   DeviceService,
   DialogService,
   HttpService,
   Logger,
   LoggingService,
   ScreenSize,
   TranslateService,
} from 'vas-mobile-api';

import { Article } from '../models/article';
import { Receiver } from '../models/receiver';
import { DataExchangeService } from '../services/dataexchange.service';
import { PrintService } from '../services/print.service';

// import { isEqual } from 'date-fns';
@Component({
  selector: 'app-new-delivery',
  templateUrl: './new-delivery.component.html',
  styleUrls: ['./new-delivery.component.css']
})

export class NewDeliveryComponent implements OnInit, AfterViewInit, OnDestroy {

  public slots: string[] = [];
  public showLoading: boolean;
  public restQuantity: number;
  public mainFormGroup: FormGroup;
  public productFormGroup: FormGroup;
  public quantityFormGroup: FormGroup;
  public truckFormGroup: FormGroup;
  public slotFormGroup: FormGroup;
  public shiptoFormGroup: FormGroup;

  private viewMode = 'ltr';
  public showAdditionalInfo = false;
  public showMobile: boolean;
  private ngUnsubscribe: Subject<void> = new Subject();
  private slideCount = 6;
  private activeSlide = 0;
  private sliderContainer: ElementRef;
  private sliderManager: HammerManager;
  private nextSlide = 0;
  private dateTomorrow: Date;
  public dateToday = new Date();
  public locale: string;

//   public balanceIds: string[] = [];
//   private products: Product[] = [];
  public balanceName: Map<string, string> = new Map<string, string>();
  public selectedBalanceSum = 0;
  public availableQtySum = 0;
  private minTonOrder = 0;
  private maxTonOrder = 0;
  public shipToKeys: string[];
  private selectedProduct: Article;
  private logger: Logger;
  public isTransfer = false;
  public isVIP = false;
  private truckReg: RegExp;
  public regions: Receiver[] = [];
  public receivers: Receiver[] = [];
  public articles: Article[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private des: DataExchangeService,
    private deviceService: DeviceService,
    private httpService: HttpService,
    private router: Router,
    private rd: Renderer2,
    private dialogService: DialogService,
    private dateService: DateService,
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private loggingService: LoggingService,
    private printService: PrintService,
    private appConfig: AppConfig,
    private dbService: DBService

  ) {
    this.truckReg = new RegExp('\\d{3,}\\s[^\\d]{3,}');
    this.logger = this.loggingService.getLogger(NewDeliveryComponent.name);

    this.dbService.getItem('isVIP').then((value) => {
      this.isVIP = value;
    }).catch(() => {
      this.isVIP = false;
    });

    this.dateTomorrow = new Date();
    this.dateTomorrow.setDate(this.dateToday.getDate() + 1);

    this.des.changeTitelBarName('LBLPANICON_NEWDELIVERY');

    this.productFormGroup = this._formBuilder.group({
      productCtrl: ['', [Validators.required, this.productBarrierValidator()]]
    });

    this.quantityFormGroup = this._formBuilder.group({
      quantityCtrl: ['', [Validators.required, this.minMaxQuantityValidator(), this.sufficientQuantityValidator()]],
      customerOrderNoCtrl: ['', [Validators.required]]
    });

    this.truckFormGroup = this._formBuilder.group({
      truckCtrl: ['', [Validators.required, this.truckPlateValidator()]],
      driverCtrl: ['', Validators.required]
    });

    this.shiptoFormGroup = this._formBuilder.group({
      regionCtrl: ['', Validators.required],
      shiptoCtrl: ['',  Validators.required]
    });

    this.slotFormGroup = this._formBuilder.group({
      slotDateCtrl: [this.dateTomorrow.toISOString().substring(0, 10), Validators.required],
      slotTimeCtrl: ['VIP', this.isVIP ? null : Validators.required]
    });

    this.mainFormGroup = this._formBuilder.group({
      productGrp: this.productFormGroup,
      quantityGrp: this.quantityFormGroup,
      truckGrp: this.truckFormGroup,
      slotGrp: this.slotFormGroup,
      shiptoGrp: this.shiptoFormGroup,

    });

  }

  ngOnInit() {
    this.quantityFormGroup.reset('');
    this.locale = this.translateService.getLanguage();
    this.httpService.getLocalResource('assets/config/newDeliveryConfig.json').subscribe((config) => {
      this.minTonOrder = config.minTonOrder;
      this.maxTonOrder = config.maxTonOrder;
    });

    this.httpService.get<BackendResponse<Receiver[]>>({
      pathId: 'getAllReceivers',
      urlParams: { regionsOnly: true }
   }).subscribe((result) => {
      this.regions = result.data;
   });

    this.httpService.get<BackendResponse<boolean>>({
      pathId: 'getAutoTransferFlag'
    }).subscribe(
      (result) => {
        this.isTransfer = result.data;
        this.logger.debug('Transfer allowed: ', this.isTransfer);
      });

   //  this.getBalanceIds();
    this.deviceService.size.pipe(takeUntil(this.ngUnsubscribe)).subscribe((size) => {
      this.showMobile = size <= ScreenSize.sm;
    });

    this.des.viewModeChange$.subscribe((viewMode) => {
      this.viewMode = viewMode;
    });

    this.slots = [];

    this.shiptoFormGroup.get('regionCtrl').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      this.shiptoFormGroup.get('shiptoCtrl').reset();
      this.httpService.get<BackendResponse<Receiver[]>>({
         pathId: 'getAllReceivers',
         urlParams: { region: data }
      }).subscribe((result) => {
         this.receivers = result.data;
      });
    });

    this.shiptoFormGroup.get('shiptoCtrl').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
        this.getProducts();
     });

    this.productFormGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data) => {
      this.showAdditonalInfoMobile(data);
      this.loadProductInfos(data.productCtrl.ARTIKEL_NR);
      if (!this.isVIP) {
        this.loadSlots(this.dateTomorrow);
      }
      this.quantityFormGroup.reset('');
      this.truckFormGroup.reset('');
      if (!this.isVIP) {
        this.slotFormGroup.get('slotTimeCtrl').reset('');
      } else {
        this.slotFormGroup.get('slotTimeCtrl').reset('VIP');
      }
    });

    this.slotFormGroup.get('slotDateCtrl').valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: Date) => {
      if (!this.isVIP) {
        this.loadSlots(data);
      } else {
        this.slotFormGroup.get('slotTimeCtrl').setValue('VIP', { emitEvent: false });
      }
    });
  }

  ngAfterViewInit() {

  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private minMaxQuantityValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = +control.value;
      const result: any = {};


      if (isNaN(value)) {
        result.noNumber = true;
      }
      if (value < this.minTonOrder) {
        result.minOrder = { value: this.minTonOrder };
        result.maxOrder = undefined;
      }
      if (value > this.maxTonOrder) {
        result.maxOrder = { value: this.maxTonOrder };
        result.minOrder = undefined;
      }
      return result;
    };

  }

  private sufficientQuantityValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = +control.value;
      const result: any = {};
      if (value > this.availableQtySum) {
        result.insufficient = true;
      }
      return result;
    };

  }

  private truckPlateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const value = control.value;
      const result: any = {};
      if (!this.truckReg.test(value)) {
        result.wrongPlate = true;
      }
      return result;
    };

  }

  private productBarrierValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const result: any = {};
      const value = control.value;
      for (const article of this.articles) {
        if (value === article.ARTIKEL_NR) {
          if ('Y' === article.LIEFERSPERR_FLAG) {
            result.barrier = true;
          }
        }
      }
      return result;
    };
  }

  public get quantityCtrlErrors(): any {
    return this.quantityFormGroup.get('quantityCtrl').errors || {};
  }

  public get truckCtrlErrors(): any {
    return this.truckFormGroup.get('truckCtrl').errors || {};
  }

  public get productCtrlErrors(): any {
    return this.productFormGroup.get('productCtrl').errors || {};
  }

  @ViewChild('slider1', { static: false }) set setSliderContainer(sliderContainer: ElementRef) {
    if (sliderContainer !== this.sliderContainer) {
      this.sliderContainer = sliderContainer;
      if (this.sliderManager) {
        this.sliderManager.off('panleft panright panend');
      }
      if (this.sliderContainer) {
        this.sliderManager = new Hammer(this.sliderContainer.nativeElement);
        this.sliderManager.get('pan').set({ threshold: 10, direction: Hammer.DIRECTION_HORIZONTAL });
        // this.sliderManager.add(new Hammer.Pan({ threshold: 10, direction: Hammer.DIRECTION_HORIZONTAL }));
        this.sliderManager.on('panleft panright', (e) => this.onPan(e));
        this.sliderManager.on('panend', (e) => this.onPanEnd(e));
      }
    }
  }

  private onPan(e) {
    if (e.center.x !== 0 && e.center.y !== 0) {
      let percentage = 100 / this.slideCount * e.deltaX / window.innerWidth; // NEW: our % calc
      let transformPercentage;
      if (this.viewMode === 'rtl') {
        transformPercentage = percentage + 100 / this.slideCount * this.activeSlide; // NEW
      } else {
        transformPercentage = percentage - 100 / this.slideCount * this.activeSlide; // NEW
      }
      this.rd.setStyle(this.sliderContainer.nativeElement, 'transform', 'translateX(' + transformPercentage + '%)');

      if ((e.velocityX > 0.3 || e.velocityX < -0.3 || e.deltaX > 150 || e.deltaX < -150)) {
        if (this.viewMode === 'rtl') {
          // This is important for a change from rtl !!!!
          percentage = -percentage;
        }
        if (percentage < 0) {
          this.nextSlide = this.activeSlide + 1;
        } else if (percentage > 0) {
          this.nextSlide = this.activeSlide - 1;
        } else {
          this.nextSlide = this.activeSlide;
        }
      } else {
        this.nextSlide = this.activeSlide;
      }
    }
  }

  private onPanEnd(e) {
    if (this.isSlideAllowed(this.nextSlide, this.activeSlide)) {
      this.goToSlide(this.nextSlide);
    } else {
      this.goToSlide(this.activeSlide);
    }
  }

  private isSlideAllowed(nextSlide: number, activeSlide: number): boolean {
    if (nextSlide > activeSlide) {
      // going forward, check if current slide is valid
      switch (activeSlide) {
        case 0:
           return this.shiptoFormGroup.valid;
         case 1:
           return this.productFormGroup.valid;
         case 2:
           return this.quantityFormGroup.valid;
         case 3:
           return this.truckFormGroup.valid;
        case 4:
          return this.slotFormGroup.valid;
        default:
          return true;
      }

    } else {
      return true;
    }

  }

  public goToSlide(slideNumber: number) {

    if (slideNumber < 0) {
      this.activeSlide = 0;
    } else if (slideNumber > this.slideCount - 1) {
      this.activeSlide = this.slideCount - 1;
    } else {
      this.activeSlide = slideNumber;
    }
    let percentage;

    if (this.viewMode === 'rtl') {
      percentage = +(100 / this.slideCount) * this.activeSlide;
    } else {
      percentage = -(100 / this.slideCount) * this.activeSlide;
    }
    // const percentage = -(100 / this.slideCount) * this.activeSlide;

    this.rd.setStyle(this.sliderContainer.nativeElement, 'transition', 'transform .3s');
    this.rd.setStyle(this.sliderContainer.nativeElement, 'transform', 'translateX(' + percentage + '%)');
    setTimeout(() => {
      this.rd.removeStyle(this.sliderContainer.nativeElement, 'transition');
    }, 300);

  }

  private print(liefer_nr: string) {
    if (liefer_nr) {
      const reportId = this.appConfig.getValue<string>('reportIdLN');
      this.showLoading = true;
      this.printService.printDNO(reportId, liefer_nr, this.showMobile).subscribe(() => {
        this.showLoading = false;
      });
    }
  }

  showAdditonalInfoMobile(value: string): void {
    if (value) {
      this.showAdditionalInfo = false;
    } else {
      this.showAdditionalInfo = false;
    }
  }

  private loadSlots(date: Date) {

    if (!this.selectedProduct) {
      this.dialogService.openConfirmDialog(
        this.translateService.translateFirstLetterUpperCase('MESSAGE:MISSING_PRODUCT'),
        this.translateService.translateFirstLetterUpperCase('MESSAGE:SELECT_A_PRODUCT'),
        this.translateService.translateFirstLetterUpperCase('BUTTON_OK'),
      );
    } else {

      const dateNow = new Date();

      let isToday = false;
      if (date.toLocaleDateString() === dateNow.toLocaleDateString()) {
        isToday = true;
      }

      const slotDate: string = this.dateService.getDate(date);
      this.logger.debug('Loading slots for', slotDate);
      if (slotDate) {
        this.httpService.get<BackendResponse<string[]>>({
          pathId: 'getEmptySlotsForProduct', urlParams: {
            date: slotDate,
            productID: this.selectedProduct.ARTIKEL_NR
          }
        }).subscribe((result) => {

          if (isToday) {
            // slot: ["06:00 - 06:30",...]
            this.slots = result.data.filter((slot) => slot.split('-')[0].trim().localeCompare(dateNow.getHours() + ':' + dateNow.getMinutes()) > -1);
          } else {
            this.slots = result.data;
          }

        });
      }
    }
  }

//   private getBalanceIds() {
//     this.httpService.get<BackendResponse<string[]>>({ pathId: 'getAllBalanceIds' }).subscribe((result) => {
//       this.balanceIds = result.data;
//     });
//   }

  public placeOrder() {

    // const slotdate = this.dateService.getDate(this.slotFormGroup.get('slotDateCtrl').value);
    this.des.showLoadingIndicator(true);
    this.httpService.get<BackendResponse<string[]>>({
      pathId: 'createYCCDelivery', urlParams: {
        shipto: this.shiptoFormGroup.get('shiptoCtrl').value.EMPFAENGER_NR,
        articleNo: this.productFormGroup.get('productCtrl').value.ARTIKEL_NR,
        amount: this.quantityFormGroup.get('quantityCtrl').value,
        customerOrderNo: this.quantityFormGroup.get('customerOrderNoCtrl').value,
        licenceplate: this.truckFormGroup.get('truckCtrl').value,
        driver: this.truckFormGroup.get('driverCtrl').value,
        timeslotTime: this.slotFormGroup.get('slotTimeCtrl').value,
        timeslotDate: this.dateService.getDate(this.slotFormGroup.get('slotDateCtrl').value)
      }, customTimeout: 1000000
    }).subscribe((result) => {
      this.des.showLoadingIndicator(false);
      this.print(result.data[0]);
      this.router.navigate(['dashboard']);
    }, (e: HttpErrorResponse) => {
      this.des.showLoadingIndicator(false);
      this.dialogService.openConfirmDialog(
        this.translateService.translateFirstLetterUpperCase('MESSAGE:ORDER_NOT_PLACED'),
        e.error ? e.error.message : e.message,
        this.translateService.translateFirstLetterUpperCase('BUTTON_OK')
      );
    }
    );
  }

//   public getProducts() {
//     const requests: Array<Observable<{ balanceId: string, description: string, productNo: string, barrier: string }>> = [];
//     for (const balanceId of this.balanceIds) {
//       requests.push(
//         this.httpService.get<BackendResponse<any>>(
//           {
//             pathId: 'getProductDescriptionByBalanceId',
//             urlParams: { balanceId }
//           })
//           .pipe(map((response) => {
//             let type = '';
//             if (balanceId.startsWith('CA')) {
//               type = 'Cash';
//             } else if (balanceId.startsWith('CR')) {
//               type = 'Credit';
//             }
//             return { balanceId, description: response.data.KURZBEZEICHNUNG + ' (' + type + ')', productNo: response.data.ARTIKEL_NR, barrier: response.data.LIEFERSPERR_FLAG };
//           })));
//     }
//     zip(...requests).subscribe((results) => {
//       results.forEach((result) => {
//         this.balanceName.set(result.balanceId, result.description);
//         this.products.push({ key: result.productNo, balanceId: result.balanceId, descp: result.productNo, barrier: result.barrier });
//       });
//       this.getPricePerProduct();
//     });
//   }

   private getProducts() {
      if (this.shiptoFormGroup.get('shiptoCtrl').value) {
         const receiverId = this.shiptoFormGroup.get('shiptoCtrl').value.EMPFAENGER_NR;
         this.httpService.get<BackendResponse<Article[]>>(
            {
               pathId: 'getAllArticles',
               urlParams: { receiverId }
            }).subscribe((result) => {
               this.articles = result.data;
               this.getPricePerProduct();
            });
      }
   }

  private getPricePerProduct() {
    // Todo umschreiben auf einen Aufruf
    const requests: Array<Observable<void>> = [];
    if (this.shiptoFormGroup.get('shiptoCtrl').value) {
        const receiverId = this.shiptoFormGroup.get('shiptoCtrl').value.EMPFAENGER_NR;
        for (const article of this.articles) {
           const articleId = article.ARTIKEL_NR;
           requests.push(
              this.httpService.get<BackendResponse<any>>({ pathId: 'getPricePerProduct', urlParams: { articleId, receiverId } }).pipe(map((response) => {
               article.price = Number(response.data.price);
              }))
           );
        }
     }
    zip(...requests).subscribe();
  }

//   public deleteSourceBalanceID(): string[] {
//     const sourceBalances: string[] = [];

//     for (const entry of this.balanceIds) {
//       console.log(entry); // 1, "string", false
//       if (!(entry.valueOf() === this.selectedProduct.balanceId)) {
//         sourceBalances.push(entry.valueOf());
//       }
//     }
//     console.log('Balance number: ', sourceBalances);
//     return sourceBalances;
//   }

//   public transferMoney() {
//     this.dialogService.openConfirmCancelDialog(
//       this.translateService.translateFirstLetterUpperCase('LABEL_TRANSFER_MONEY'),
//       this.translateService.translateFirstLetterUpperCase('MESSAGE:TRANSFER_MONEY'),
//       this.translateService.translateFirstLetterUpperCase('BUTTON_YES'),
//       this.translateService.translateFirstLetterUpperCase('BUTTON_CLOSE'))
//       .subscribe((confirmed) => {
//         if (confirmed) {
//           this.des.showLoadingIndicator(true);
//           const requestedValue: number = Number(this.quantityFormGroup.get('quantityCtrl').value);
//           const amountRequested: number = requestedValue * this.selectedProduct.price;
//           const difference: number = amountRequested - this.selectedBalanceSum;

//           this.httpService.get<BackendResponse<any>>({
//             pathId: 'transferMoneyFromAccounts', urlParams:
//             {
//               target: this.selectedProduct.balanceId,
//               sourceAccounts: this.deleteSourceBalanceID(),
//               amount: difference
//             }, customTimeout: 999999999
//           }).subscribe((response) => {
//             this.des.showLoadingIndicator(false);
//             this.loadProductInfos(this.selectedProduct.balanceId);
//             this.dialogService.openConfirmDialog(
//               this.translateService.translateFirstLetterUpperCase('LABEL_TRANSFER_MONEY'),
//               this.translateService.translateFirstLetterUpperCase('MESSAGE:TRANSFER_MONEY_SUCESS'),
//               this.translateService.translateFirstLetterUpperCase('BUTTON_OK'),
//             );
//           }, (e) => {
//             this.logger.error(e);
//             this.des.showLoadingIndicator(false);
//             this.dialogService.openConfirmDialog(
//               this.translateService.translateFirstLetterUpperCase('LABEL_ERROR_TRANSFER_MONEY'),
//               this.translateService.translateFirstLetterUpperCase('MESSAGE:NO_TRANSFER_MONEY'),
//               this.translateService.translateFirstLetterUpperCase('BUTTON_OK')
//             );
//           });
//         }
//       });

//   }

  private loadProductInfos(articleId: string) {

    if (!articleId) {
      return;
    }

    for (const product of this.articles) {
      if (articleId === product.ARTIKEL_NR) {
        this.selectedProduct = product;
      }
    }

    this.des.showLoadingIndicator(true);
    this.httpService.get<BackendResponse<number>>({
      pathId: 'getBalanceSumYCC',
      withErrorNotification: false, customTimeout: 30000
    }).subscribe((response) => {
      this.selectedBalanceSum = response.data;

      if (this.selectedProduct.price === 0.0) {
        this.availableQtySum = 0;
      } else {
        this.availableQtySum = this.selectedBalanceSum / this.selectedProduct.price;
        this.quantityFormGroup.get('quantityCtrl').patchValue(this.quantityFormGroup.get('quantityCtrl').value);
      }
      this.des.showLoadingIndicator(false);
    }, (e) => {
      this.des.showLoadingIndicator(false);
    });
  }

  public ejectNewDelivery() {

    this.dialogService.openConfirmCancelDialog(
      this.translateService.translateFirstLetterUpperCase('LABEL_CONFIRMATION'),
      this.translateService.translateFirstLetterUpperCase('MESSAGE:CANCEL_DELIVERY'),
      this.translateService.translateFirstLetterUpperCase('BUTTON_YES'),
      this.translateService.translateFirstLetterUpperCase('BUTTON_NO')

    ).subscribe((res) => {
      if (res === true) {
        this.router.navigate(['dashboard']);
      }

    });

  }

  // public get isVIP() {
  //   return this.route.snapshot.data.VIP;
  // }
}
